// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-details {
  height: 100%;
  background: #f5f7fa;
}

.header {
  background: var(--ion-color-primary);
  color: white;
  padding: 20px;
  position: relative;
  text-align: center;
}
.header h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}
.header .close-button {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  --color: white;
}

.content {
  padding: 20px;
}

.details-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.price-section {
  text-align: center;
  margin-bottom: 24px;
}
.price-section .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.price-section .period {
  font-size: 1rem;
  color: var(--ion-color-medium);
}

.info-section {
  margin-bottom: 24px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
}
.info-item:last-child {
  border-bottom: none;
}
.info-item ion-icon {
  font-size: 24px;
  color: var(--ion-color-primary);
  margin-right: 16px;
}
.info-item .info-text {
  display: flex;
  flex-direction: column;
}
.info-item .info-text .label {
  font-size: 0.9rem;
  color: var(--ion-color-medium);
  margin-bottom: 4px;
}
.info-item .info-text .value {
  font-size: 1rem;
  color: var(--ion-color-dark);
  font-weight: 500;
}

.description h3 {
  color: var(--ion-color-dark);
  font-size: 1.1rem;
  margin-bottom: 12px;
}
.description p {
  color: var(--ion-color-medium);
  line-height: 1.6;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modals/package-subscription-details/package-subscription-details.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,oCAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AAAJ;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;AADJ;AAIE;EACE,eAAA;EACA,8BAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;AALJ;AAOI;EACE,iBAAA;EACA,8BAAA;EACA,kBAAA;AALN;AAQI;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;AANN;;AAYE;EACE,4BAAA;EACA,iBAAA;EACA,mBAAA;AATJ;AAYE;EACE,8BAAA;EACA,gBAAA;EACA,SAAA;AAVJ","sourcesContent":[".subscription-details {\r\n  height: 100%;\r\n  background: #f5f7fa;\r\n}\r\n\r\n.header {\r\n  background: var(--ion-color-primary);\r\n  color: white;\r\n  padding: 20px;\r\n  position: relative;\r\n  text-align: center;\r\n\r\n  h1 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .close-button {\r\n    position: absolute;\r\n    left: 8px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    --color: white;\r\n  }\r\n}\r\n\r\n.content {\r\n  padding: 20px;\r\n}\r\n\r\n.details-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\r\n}\r\n\r\n.price-section {\r\n  text-align: center;\r\n  margin-bottom: 24px;\r\n\r\n  .price {\r\n    font-size: 2.5rem;\r\n    font-weight: 700;\r\n    color: var(--ion-color-primary);\r\n  }\r\n\r\n  .period {\r\n    font-size: 1rem;\r\n    color: var(--ion-color-medium);\r\n  }\r\n}\r\n\r\n.info-section {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 16px 0;\r\n  border-bottom: 1px solid #eee;\r\n\r\n  &:last-child {\r\n    border-bottom: none;\r\n  }\r\n\r\n  ion-icon {\r\n    font-size: 24px;\r\n    color: var(--ion-color-primary);\r\n    margin-right: 16px;\r\n  }\r\n\r\n  .info-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .label {\r\n      font-size: 0.9rem;\r\n      color: var(--ion-color-medium);\r\n      margin-bottom: 4px;\r\n    }\r\n\r\n    .value {\r\n      font-size: 1rem;\r\n      color: var(--ion-color-dark);\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.description {\r\n  h3 {\r\n    color: var(--ion-color-dark);\r\n    font-size: 1.1rem;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  p {\r\n    color: var(--ion-color-medium);\r\n    line-height: 1.6;\r\n    margin: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
